import { Component } from 'react'
import PropTypes from 'prop-types'

export const handleBeforeunload = event => {
  const returnValue = '放棄提案？'
  if (typeof returnValue === 'string') {
    event.returnValue = returnValue
    return returnValue
  }
}

// force to unbind beforeunload event
export const unbindBeforeunload = () => global.window && global.window.removeEventListener('beforeunload', handleBeforeunload)

class Beforeunload extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  componentDidMount () {
    global.window && global.window.addEventListener('beforeunload', handleBeforeunload)
  }

  componentWillUnmount () {
    this.unbind()
  }

  unbind = unbindBeforeunload

  render () {
    const { children = null } = this.props
    return children
  }
}

export default Beforeunload
